{% block acris_blog_detail %}
    <sw-page class="acris-blog-detail" v-if="item">

        {% block acris_blog_detail_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_blog_detail_smart_bar_header_title %}
                    <h2>{{ item.internalName || $tc('acris-blog.detail.textHeadline') }}</h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_detail_smart_bar_language %}
            <template #language-switch>
                <sw-language-switch
                        :save-changes-function="saveOnLanguageChange"
                        :abort-change-function="abortOnLanguageChange"
                        @on-change="onChangeLanguage"
                />
            </template>
        {% endblock %}

        {% block acris_blog_detail_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_blog_detail_smart_bar_actions_cancel %}
                    <mt-button :disabled="item.isLoading" @click="$router.push({ name: 'acris.blog.index' })"
                               size="default" variant="secondary">
                        {{ $tc('acris-blog.detail.buttonCancel') }}
                    </mt-button>
                {% endblock %}

                {% block acris_blog_detail_smart_bar_actions_save %}
                    <sw-button-process
                            :isLoading="isLoading"
                            :processSuccess="isSaveSuccessful"
                            variant="primary"
                            :disabled="!item.publicationDate || !item.internalName || !item.title || (!item.contentType === 'layout' && !item.cmsPageId)"
                            @update:processSuccess="saveFinish"
                            @click="onSave">
                        {{ $tc('acris-blog.detail.buttonSave') }}
                    </sw-button-process>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_detail_content %}
            <template #content>
                <sw-card-view>

                    {% block acris_blog_detail_settings_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-blog-detail-settings"
                                 :title="$tc('acris-blog.detail.cardSettingsTitle')">

                            <sw-container columns="1fr 1fr" gap="0 32px">
                                {% block acris_blog_detail_internal_name %}
                                    <mt-text-field v-model="item.internalName"
                                                   required
                                                   :label="$tc('acris-blog.detail.fieldTitleLabelInternalName')"
                                                   :placeholder="placeholder(item, 'internalName', $tc('acris-blog.detail.fieldTitlePlaceholderInternalName'))">
                                    </mt-text-field>
                                {% endblock %}
                            </sw-container>

                            <sw-container columns="1fr 1fr" gap="0 32px"
                                          class="acris-blog-detail-date-author-container">
                                {% block acris_blog_detail_publication_date %}
                                    <mt-datepicker v-model="publicationDate"
                                                   dateType="datetime"
                                                   :label="$tc('acris-blog.detail.fieldTitleLabelPublicationDate')"
                                                   required/>
                                {% endblock %}

                                {% block acris_blog_detail_publication_date_author %}
                                    <sw-entity-single-select
                                            v-model:value="item.blogAuthorId"
                                            :label="$tc('acris-blog.detail.fieldTitleLabelAuthor')"
                                            entity="acris_blog_author"
                                            :criteria="authorCriteria"
                                            show-clearable-button>
                                        <template #selection-label-property="{ item }">
                                            {{ item.firstName }} {{ item.lastName }}
                                        </template>

                                        <template #result-label-property="{ item }">
                                            {{ item.firstName }} {{ item.lastName }}
                                        </template>
                                    </sw-entity-single-select>
                                {% endblock %}
                            </sw-container>

                            <sw-container columns="1fr 1fr 1fr" gap="0 32px">
                                {% block acris_blog_detail_active %}
                                    <mt-switch v-model="item.active"
                                               bordered
                                               :label="$tc('acris-blog.detail.fieldTitleLabelActive')">
                                    </mt-switch>
                                {% endblock %}

                                {% block acris_blog_detail_active_from %}
                                    <mt-datepicker v-model="activeFrom"
                                                   dateType="date"
                                                   :label="$tc('acris-blog.detail.fieldTitleLabelActiveFrom')"/>
                                {% endblock %}

                                {% block acris_blog_detail_active_to %}
                                    <mt-datepicker v-model="activeTo"
                                                   dateType="date"
                                                   :label="$tc('acris-blog.detail.fieldTitleLabelActiveTo')">
                                    </mt-datepicker>
                                {% endblock %}
                            </sw-container>

                        </mt-card>
                    {% endblock %}

                    {% block acris_blog_detail_display_conditions_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-blog-detail-display-conditions"
                                 :title="$tc('acris-blog.detail.cardDisplayConditionsTitle')">

                            {% block acris_blog_detail_groups %}
                                <sw-entity-many-to-many-select
                                        v-if="item && item.blogGroups"
                                        :localMode="true"
                                        labelProperty="internalName"
                                        :label="$tc('acris-blog.detail.fieldTitleLabelGroups')"
                                        :placeholder="$tc('acris-blog.detail.fieldTitlePlaceholderGroups')"
                                        :helpText="$tc('acris-blog.detail.fieldTitleHelpTextGroups')"
                                        v-model:entity-collection="item.blogGroups"
                                        :entity-collection="item.blogGroups">
                                </sw-entity-many-to-many-select>
                            {% endblock %}

                            {% block acris_blog_detail_sales_channels %}
                                <sw-entity-many-to-many-select
                                        v-if="item && item.salesChannels"
                                        :localMode="true"
                                        :label="$tc('acris-blog.detail.fieldTitleLabelSalesChannels')"
                                        :placeholder="$tc('acris-blog.detail.fieldTitlePlaceholderSalesChannels')"
                                        :helpText="$tc('acris-blog.detail.fieldTitleHelpTextSalesChannels')"
                                        :entity-collection="item.salesChannels"
                                        @update:entity-collection="onSalesChannelChange">
                                </sw-entity-many-to-many-select>
                            {% endblock %}

                            {% block acris_blog_detail_rules %}
                                <sw-entity-many-to-many-select
                                        v-if="item && item.rules"
                                        :localMode="true"
                                        :label="$tc('acris-blog.detail.fieldTitleLabelRules')"
                                        :placeholder="$tc('acris-blog.detail.fieldTitlePlaceholderRules')"
                                        :helpText="$tc('acris-blog.detail.fieldTitleHelpTextRules')"
                                        :entity-collection="item.rules"
                                        @update:entity-collection="onRulesChange">
                                </sw-entity-many-to-many-select>
                            {% endblock %}

                        </mt-card>
                    {% endblock %}

                    {% block acris_blog_detail_content_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-blog-detail-content"
                                 :title="$tc('acris-blog.detail.cardContentTitle')">

                            {% block acris_blog_detail_title %}
                                <mt-text-field v-model="item.title"
                                               required
                                               :label="$tc('acris-blog.detail.fieldTitleLabelTitle')"
                                               :placeholder="placeholder(item, 'title', $tc('acris-blog.detail.fieldTitlePlaceholderTitle'))">
                                </mt-text-field>
                            {% endblock %}

                            {% block acris_blog_detail_subtitle %}
                                <mt-text-field v-model="item.subtitle"
                                               :label="$tc('acris-blog.detail.fieldSubtitleLabelTitle')"
                                               :placeholder="placeholder(item, 'subtitle', $tc('acris-blog.detail.fieldSubtitlePlaceholderTitle'))">
                                </mt-text-field>
                            {% endblock %}

                            {% block acris_blog_detail_description %}
                                <sw-text-editor v-model:value="item.boxDescription"
                                                :label="$tc('acris-blog.detail.fieldTitleLabelDescription')">
                                </sw-text-editor>
                            {% endblock %}

                            {% block acris_blog_detail_content_direct %}
                                <sw-text-editor v-model:value="item.content"
                                                :label="$tc('acris-blog.detail.fieldTitleLabelContent')">
                                </sw-text-editor>
                            {% endblock %}

                            {% block acris_blog_detail_image %}
                                <sw-upload-listener
                                        :uploadTag="uploadCoverTag"
                                        autoUpload
                                        @media-upload-finish="setMediaItem">
                                </sw-upload-listener>
                                <sw-media-upload-v2
                                        variant="regular"
                                        class="acris-blog-detail__image-upload"
                                        :uploadTag="uploadCoverTag"
                                        :source="mediaItem"
                                        :allowMultiSelect="false"
                                        :label="$tc('acris-blog.detail.fieldTitleLabelMedia')"
                                        :defaultFolder="blogsEntityName"
                                        :sourceContext="item"
                                        @media-drop="onDropMedia"
                                        @media-upload-sidebar-open="onOpenMediaModal"
                                        @media-upload-remove-image="onUnlinkAvatar">
                                </sw-media-upload-v2>
                            {% endblock %}

                            {% block acris_blog_detail_image_media_modal %}
                                <sw-media-modal-v2
                                        variant="full"
                                        v-if="mediaModalIsOpen"
                                        :entityContext="item.entityName"
                                        :allowMultiSelect="false"
                                        :initialFolderId="mediaDefaultFolderId"
                                        @media-upload-remove-image="onUnlinkAvatar"
                                        @media-modal-selection-change="onSelectionChanges"
                                        @modal-close="onCloseModal">
                                </sw-media-modal-v2>
                            {% endblock %}

                            {% block acris_blog_detail_additional_media %}
                                <div class="acris-blog-detail__additional-media">
                                    <div class="sw-media-upload-v2">
                                        <label class="sw-media-upload-v2__header">
                                            {{ $tc('acris-blog.detail.fieldTitleLabelAdditionalMedia') }}
                                        </label>
                                    </div>
                                    <sw-media-list-selection-v2
                                            v-if="item"
                                            :entityMediaItems="additionalMediaCollection"
                                            :entity="item"
                                            :upload-tag="uploadTag"
                                            :default-folder-name="blogsEntityName"
                                            @upload-finish="onAdditionalMediaUpload"
                                            @item-remove="onAdditionalMediaRemove"
                                            @open-sidebar="onOpenAdditionalMediaModal"
                                            @item-sort="onAdditionalMediaSort">
                                    </sw-media-list-selection-v2>
                                </div>
                            {% endblock %}

                            {% block acris_blog_detail_additional_media_modal %}
                                <sw-media-modal-v2
                                        variant="full"
                                        v-if="additionalMediaModalIsOpen"
                                        :entityContext="item.entityName"
                                        :allowMultiSelect="true"
                                        :initialFolderId="mediaDefaultFolderId"
                                        @media-upload-remove-image="onAdditionalMediaRemove"
                                        @media-modal-selection-change="onAdditionalMediaSelectionChanges"
                                        @modal-close="onCloseAdditionalMediaModal">
                                </sw-media-modal-v2>
                            {% endblock %}

                            <sw-container columns="1fr 1fr" gap="32px" :style="{ 'margin-top': '24px' }">
                                {% block acris_blog_detail_content_type %}
                                    <mt-select v-model="item.contentType"
                                               required
                                               :options="layoutOptions"
                                               :label="$tc('acris-blog.detail.fieldTitleLabelContentType')">
                                    </mt-select>
                                {% endblock %}
                            </sw-container>
                        </mt-card>
                    {% endblock %}

                    {% block acris_blog_detail_layout_card %}
                        <mt-card :isLoading="isLoading" v-if="item && item.contentType === 'layout'"
                                 position-identifier="acris-blog-detail-shopping-experience-layout"
                                 :title="$tc('acris-blog.detail.ShoppingExperienceLayoutAssignmentTitle')">
                            <div class="acris-blog-detail-cms-page" v-if="item.contentType === 'layout'">
                                {% block acris_blog_detail_layout_card_content_type %}
                                    <sw-product-layout-assignment
                                            :cmsPage="cmsPage"
                                            @modal-layout-open="openLayoutModal"
                                            @button-edit-click="openInPageBuilder"
                                            @button-delete-click="onLayoutReset">
                                    </sw-product-layout-assignment>
                                {% endblock %}

                                {% block acris_blog_detail_layout_card_layout_modal %}
                                    <sw-cms-layout-modal
                                            v-if="showLayoutModal"
                                            :headline="$tc('acris-account-menu.detail.textHeadline')"
                                            @modal-layout-select="onLayoutSelect"
                                            @modal-close="closeLayoutModal">
                                    </sw-cms-layout-modal>
                                {% endblock %}
                            </div>
                            <mt-banner
                                    v-if="item.contentType === 'layout' && !item.cmsPageId"
                                    variant="info"
                                    class="acris-blog-detail-layout-card__shopping-experience-banner"
                            >
                                <div v-html="$tc('acris-blog.detail.alertBannerForShoppingExperienceInfo', { url: '#/sw/extension/config/AcrisBlog' })"></div>
                            </mt-banner>
                        </mt-card>
                    {% endblock %}

                    {% block acris_blog_detail_products_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-blog-detail-products"
                                 :title="$tc('acris-blog.detail.cardProductsTitle')">

                            {% block acris_blog_detail_products %}
                                <acris-entity-many-to-many-select
                                        v-if="item && item.products"
                                        :localMode="true"
                                        :display-variants="true"
                                        :criteria="productCriteria"
                                        :context="productContext"
                                        :label="$tc('acris-blog.detail.fieldTitleLabelProducts')"
                                        :placeholder="$tc('acris-blog.detail.fieldTitlePlaceholderProducts')"
                                        :helpText="$tc('acris-blog.detail.fieldTitleHelpTextProducts')"
                                        :entity-collection="item.products"
                                        @update:entity-collection="onItemProductChange">

                                    {% block sw_select_result_item_text %}
                                        <template #selection-label-property="{ item }">
                                            <sw-product-variant-info :variations="item.variation"
                                                                     class="product-entity-selected">
                                                {{ item.productNumber }} - {{ item.translated.name || item.name }}
                                            </sw-product-variant-info>
                                        </template>
                                    {% endblock %}

                                    {% block sw_entity_many_to_many_select_base_results_list_result_label %}
                                        <template #result-label-property="{ item, index }">
                                            <sw-product-variant-info :variations="item.variation"
                                                                     class="product-entity-selected">
                                                {{ item.productNumber }} - {{ item.translated.name || item.name }}
                                            </sw-product-variant-info>
                                        </template>
                                    {% endblock %}
                                </acris-entity-many-to-many-select>

                                <h3 class="my-3">{{ $tc('acris-blog.detail.productOrProductGroup') }}</h3>
                            {% endblock %}

                            {% block acris_blog_detail_product_streams %}
                                <sw-entity-many-to-many-select
                                        v-if="item && item.productStreams"
                                        :localMode="true"
                                        :label="$tc('acris-blog.detail.fieldTitleLabelProductStreams')"
                                        :placeholder="$tc('acris-blog.detail.fieldTitlePlaceholderProductStreams')"
                                        :helpText="$tc('acris-blog.detail.fieldTitleHelpTextProductStreams')"
                                        :entity-collection="item.productStreams"
                                        @update:entity-collection="onProductStreamChange">
                                </sw-entity-many-to-many-select>
                            {% endblock %}

                        </mt-card>
                    {% endblock %}

                    {% block acris_blog_detail_seo_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-blog-detail-seo"
                                 :title="$tc('acris-blog.detail.cardSeoTitle')">

                            {% block acris_blog_detail_seo_url %}
                                <mt-text-field v-model="item.seoUrl"
                                               class="acris-blog-detail__item_seo_url"
                                               :label="$tc('acris-blog.detail.fieldTitleLabelSeoUrl')"
                                               :helpText="$tc('acris-blog.detail.fieldTitleHelpTextSeoUrl')"
                                               :placeholder="placeholder(item, 'seoUrl', $tc('acris-blog.detail.fieldTitlePlaceholderSeoUrl'))">
                                </mt-text-field>
                            {% endblock %}

                            {% block acris_blog_detail_meta_title %}
                                <mt-text-field v-model="item.metaTitle"
                                               class="acris-blog-detail__item_meta_title"
                                               :label="$tc('acris-blog.detail.fieldTitleLabelMetaTitle')"
                                               :helpText="$tc('acris-blog.detail.fieldTitleHelpTextMetaTitle')"
                                               :placeholder="placeholder(item, 'metaTitle', $tc('acris-blog.detail.fieldTitlePlaceholderMetaTitle'))">
                                </mt-text-field>
                            {% endblock %}

                            {% block acris_blog_detail_meta_description %}
                                <mt-text-field v-model="item.metaDescription"
                                               class="acris-blog-detail__item_meta_description"
                                               :label="$tc('acris-blog.detail.fieldTitleLabelMetaDescription')"
                                               :helpText="$tc('acris-blog.detail.fieldTitleHelpTextMetaDescription')"
                                               :placeholder="placeholder(item, 'metaDescription', $tc('acris-blog.detail.fieldTitlePlaceholderMetaDescription'))">
                                </mt-text-field>
                            {% endblock %}

                        </mt-card>
                    {% endblock %}

                </sw-card-view>
            </template>
        {% endblock %}

    </sw-page>
{% endblock %}
